// extracted by mini-css-extract-plugin
module.exports = {"result":"result_result__3xmPM","icon":"result_icon__10ZMI"};